<mapfre-card 
        [singleCard]="false"
        [additionalClasses]="'information'">
        <router-outlet></router-outlet>
</mapfre-card>